import { setStorageSSOToken } from '../helpers/Auth';

const useSetTokenSSO = () => {
  return accessToken => {
    if (!accessToken) return false;
    setStorageSSOToken(accessToken);
    return true;
  };
};

export default useSetTokenSSO;
